module.exports = __webpack_public_path__ + "media/images/affiliation_logos/affiliate_logo_duke-9b36da04465f753fb08da2fa65908905.png";